import colors from '../config/colors.json'
import { Scatter } from 'react-chartjs-2'
import { useRef } from 'react'
import { sweepClipPlugin, useAnnotationEntrance, useChartEntrance } from '../helpers/chartAnimation'

// `animate` is only true after the dashboard fired the animate event, the chart is remounted with a
// new key each time so the entrance runs from the start again.
const MilitaryChart = ({ match, annotations, height, militaryLead, animate }) => {
	const chartRef = useRef(null)
	const shownAnnotations = useAnnotationEntrance(annotations, animate)
	useChartEntrance(chartRef, animate)

	return (
		<div className="charts__military">
			<h1 className="charts__military__title charts__title">Military Value Lead</h1>
			<Scatter
				className=""
				ref={chartRef}
				plugins={[sweepClipPlugin]}
				datasetIdKey="id"
				height={height}
				style={{ maxHeight: height }}
				options={{
					maintainAspectRatio: false,
					aspectRatio: 1,
					animation: false,
					parsing: false,
					normalized: true,
					legend: {
						display: false,
					},
					title: {
						display: false,
					},
					scales: {
						x: {
							min: 20,
							ticks: {
								stepSize: 60,
								callback: (v) => (v >= 30 ? (v / 60).toString() + ' min' : ''),
								color: 'white',
							},
							grid: {
								color: 'rgba(255,255,255,.3)',
							},
						},
						y: {
							beginAtZero: true,
							suggestedMax: 150,
							suggestedMin: 150,
							ticks: {
								callback: (v) => Math.abs(v).toString(),
								color: 'white',
								font: { size: 20 },
							},
							grid: {
								color: 'rgba(255,255,255,.3)',
							},
							afterFit: (axis) => {
								axis.width = Math.max(axis.width, 60)
							},
						},
					},
					plugins: {
						legend: {
							display: false,
						},
						annotation: {
							annotations: shownAnnotations,
						},
					},
				}}
				data={{
					datasets: [
						{
							id: 'militaryLead',
							label: '',
							type: 'line',
							data: militaryLead,
							borderColor: 'black',
							borderWidth: 1,
							pointRadius: 0,
							fill: {
								target: 'origin',
								above: colors[match.leftPlayer.color]?.mainColor, // And leftColor above the origin
								below: colors[match.rightPlayer.color]?.mainColor, // Area will be rightColor below the origin
							},
						},
					],
				}}
			/>
		</div>
	)
}

export { MilitaryChart }
